/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 22/11/2023
 */
import BaseObject from "@shared/BaseObject.js";

export default class ProfileShort extends BaseObject {

	id: string = null
	name: string = null

	constructor(baseProfile) {
		super();
		if(baseProfile){
			this.id = baseProfile.id;
			this.name = baseProfile.name;
		}
	}
}
